module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-page-navigation-rigth-arrow-default.ca0ea71e.svg";